import React, {useState, useEffect} from 'react';
import LogoWebM from '../../assets/Logo_002.webm';
import LogoMov from '../../assets/Logo_002.mov';
import StaticLogo from '../../assets/MALogo.svg';

const PageLoader = (isLoading = true) => {
  const [message, setMessage] = useState('');

  const isPhone = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

  // Function to detect browser
  const getVideoSource = () => {
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    return isSafari ? LogoMov : LogoWebM;
  };

  const loadingMessages = [
    "Loading...",
    "Please wait...",
    "Almost there...",
    "This is taking longer than usual...",
    "Good things come to those who wait...",
    "Getting things ready for you...",
    "Okay, this is taking forever...",
    "Might as well make a sandwich while you wait...",
    "Loading... still...",
    "Okay, maybe it's time to switch internet provider...",
    "Check your connection, or maybe the server is just slow...",
    "Try again later, or just take a nap...",
  ];

  useEffect(() => {
    // Simulate loading time
    // const timer = setTimeout(() => {
    //   setIsLoading(false);
    // }, 6000); // 6 seconds loading time

    let messageIndex = 0;
    const messageTimer = setInterval(() => {
      if (messageIndex < loadingMessages.length) {
        setMessage(loadingMessages[messageIndex]);
        messageIndex++;
      } else {
        clearInterval(messageTimer);
      }
    }, 10000); // Show a new message every 10 seconds

    return () => { 
      // clearTimeout(timer);
      clearInterval(messageTimer);
    };
  }, []);

  return (
    <div 
    className='wrapper'
    style={{ 
      // backgroundColor: '#363232ff', 
      // height: '100vh', 
      // display: 'flex', 
      // flexDirection: 'column',
      // justifyContent: 'center', 
      // alignItems: 'center',
      // color: 'white' 
    }}>
      <div className='background-grid d-flex flex-column justify-content-center align-items-center' style={{minHeight: '100vh'}}>
        
        {isPhone ? (
          <img 
            className="logo-animation mb-3" src={StaticLogo} alt="Logo" />
        ) : (
          <video className='logo-animation' autoPlay muted {...(isLoading && { loop: true })}>
            <source src={getVideoSource()} type={getVideoSource() === LogoMov ? 'video/quicktime' : 'video/webm'} />
            Your browser does not support the video tag.
          </video>
        )}
        {/* <div>
          <h1 className='text-center' style={{ marginTop: '0px' }}>Loading<span className="dots"></span></h1>
        </div> */}
        {/* Show loading messages one by one every 10 seconds */}
        <h3 className='text-center'>{message}</h3>
      </div>
      </div>
  );
};

export default PageLoader;